import { CardModel } from 'mvppoker-portal-common/api'
import { CardModelUtils } from 'mvppoker-portal-common/model/CardModelUtils'
import { CardSuitTypeUtils } from 'mvppoker-portal-common/model/CardSuitTypeUtils'
import { CardValueTypeUtils } from 'mvppoker-portal-common/model/CardValueTypeUtils'

export const getDeckUrl = (idx: number) => `/images/cards/deck_${idx}`
export const getCardUrl = (deck: number, card: CardModel) =>
	`${getDeckUrl(deck)}/card_${CardSuitTypeUtils.GetId(card.suit)}_${CardValueTypeUtils.GetId(card.value)}.webp`
export const getCardBackUrl = (deck: number) => `${getDeckUrl(deck)}/card_back.webp`

export const getAllCardsUrl = (deck: number) =>
	CardModelUtils.CreateDeck()
		.map((card) => getCardUrl(deck, card))
		.concat([getCardBackUrl(deck)])
